import { useState, useEffect } from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import jwtDecode from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import { useTheme } from '@mui/material/styles';

import { RootState } from '../../store/store';
import { updateLoginUserDetails } from '../../store/slices/loginSlice';
import { useAppSelector, useAppDispatch } from '../../store/hooks/useTypedSelector';
import TextFieldWrapper from '../common/FormsUI/TextFieldWrapper';
import ButtonWrapper from '../common/FormsUI/ButtonWrapper';
import Notification from '../common/Notification';
import { COLORS } from '../../utils/ColorsTheme';
import { oathResponse, userDetailsResponse, loginDetails } from '../../types';

const Login = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isUserLoginReducer = useAppSelector((state: RootState) => state.login.isLogin);
  const isUserLoginSession = localStorage.getItem('isLogin') === 'true';
  const [isUserLogin, setUserLogin] = useState(isUserLoginReducer || isUserLoginSession);
  const [showSkeleton, updateSkeleton] = useState<boolean>(true);
  const [showMessage, setMessage] = useState<string>('');
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const validationSchema = Yup.object().shape({
    email: Yup.string().email('Invalid Email').required('Email Required'),
    password: Yup.string()
      .min(8, 'Password is too short - should be 8 chars minimum.')
      .required('Password Required'),
  });
  const initialValues = {
    email: '',
    password: '',
  };
  const onSuccess = (res: oathResponse) => {
    if (res.credential) {
      const userDetails: userDetailsResponse = jwtDecode(res.credential);
      dispatch(updateLoginUserDetails(userDetails));
      localStorage.setItem('userDetails', JSON.stringify(userDetails));
      localStorage.setItem('isLogin', 'true');
      setUserLogin(true);
    }
  };
  const onScriptLoadSuccess = () => {
    updateSkeleton(false);
  };
  const onSubmit = (loginData: loginDetails) => {
    const { email, password } = loginData;
    if (email === 'admin@gmail.com' && password === 'admin123') {
      const userDetails = {
        email: email,
        picture: '',
        name: 'Admin User',
      };
      dispatch(updateLoginUserDetails(userDetails));
      localStorage.setItem('userDetails', JSON.stringify(userDetails));
      localStorage.setItem('isLogin', 'true');
      setUserLogin(true);
      return true;
    } else {
      setMessage('');
      setTimeout(() => {
        setMessage('Please Entered Valid Credentials!');
      }, 100);
      return false;
    }
  };
  const handleClose = () => {
    setMessage('');
  };
  useEffect(() => {
    if (isUserLogin) {
      navigate('/cart', { replace: true });
    }
  }, [isUserLogin]);

  return (
    <div className='d-flex justify-content-center align-items-center main-container'>
      <div
        className='card col-lg-4 col-md-6 col-sm-12 p-3'
        style={{
          backgroundColor: isDarkMode ? COLORS.secondaryDarkMode : COLORS.secondaryLightMode,
        }}
      >
        <Box
          className='d-flex justify-content-center align-items-center flex-column'
          sx={{
            '& > :not(style)': { m: 1, width: '25ch' },
          }}
        >
          <Typography
            gutterBottom
            variant='h5'
            component='div'
            style={{ textAlign: 'center' }}
            className={`fw-bold ${isDarkMode ? 'text-white' : 'text-dark'}`}
          >
            LOGIN
          </Typography>
          <div className='dropdown-divider'></div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={async (values, { resetForm }) => {
              const loginSuccess = await onSubmit(values);
              if (loginSuccess) {
                resetForm();
              }
            }}
          >
            <Form className='d-flex justify-content-center align-items-center flex-column'>
              <div className='form-group'>
                <TextFieldWrapper name='email' type='Text' label='Email' />
              </div>
              <div className='form-group'>
                <TextFieldWrapper name='password' type='password' label='Password' />
              </div>
              <div className='form-group'>
                <ButtonWrapper>Login</ButtonWrapper>
              </div>
            </Form>
          </Formik>
          <div className='text-center form-group'>
            <small className={`form-text ${isDarkMode ? 'text-white' : 'text-dark'}`}>
              Test Credentials For Testing admin@gmail.com/admin123.
            </small>
          </div>
          <Typography
            gutterBottom
            variant='h5'
            component='div'
            style={{ textAlign: 'center' }}
            className={`fw-bold ${isDarkMode ? 'text-white' : 'text-dark'}`}
          >
            OR
          </Typography>
          <div className='form-group d-flex justify-content-center align-items-center'>
            {showSkeleton && (
              <Skeleton
                variant='rounded'
                height={44}
                width={290}
                style={{ marginBottom: '-42px' }}
              />
            )}
            <GoogleOAuthProvider
              clientId='1043243184401-666gvs6903rkca1leumhdritch4uqsdq.apps.googleusercontent.com'
              onScriptLoadSuccess={onScriptLoadSuccess}
            >
              <GoogleLogin
                onSuccess={onSuccess}
                onError={() => {
                  console.log('Login Failed');
                }}
                theme={isDarkMode ? 'filled_black' : 'filled_blue'}
              />
            </GoogleOAuthProvider>
          </div>
        </Box>
      </div>
      {showMessage !== '' && (
        <Notification showMessage={showMessage} handleClose={handleClose} isSuccess={false} />
      )}
    </div>
  );
};

export default Login;
